<template>
  <div>
    <Step />
    <PilihPaket v-if="dataPermohonan.tahap === 1" />
    <PilihLayanan v-if="dataPermohonan.tahap === 2" />
    <PengisianFormulir v-if="dataPermohonan.tahap === 3" />
    <DownloadFormulir v-if="dataPermohonan.tahap === 4" />
    <UploadBerkas v-if="dataPermohonan.tahap === 5" />
  </div>
</template>

<script>
import Step from './../langkahpermohonan/Step.vue'
import PilihPaket from './PilihPaket.vue'
import PilihLayanan from './PilihLayanan.vue'
import PengisianFormulir from './PengisianFormulir.vue'
import DownloadFormulir from './DownloadFormulir.vue'
import UploadBerkas from './UploadBerkas.vue'

export default {
    data() {
        return {
            // step: 1
        }
    },
    components: {
        Step, PilihPaket, PilihLayanan, PengisianFormulir, DownloadFormulir, UploadBerkas
    },
    computed: {
        dataPermohonan(){
            return this.$store.getters.getDataPermohonan
        }
    },
    // props: ['dataPermohonan'],
    // methods:{
    //     setStep(val){
    //         this.step = val
    //         this.dataPermohonan.tahap = val
    //         this.$store.dispatch('setDataPermohonan', this.dataPermohonan)
    //     }
    // },
    created(){
        // this.step = this.dataPermohonan.tahap
    }
}
</script>